import React, { memo } from 'react';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';

import * as S from './style';

interface IProps {
  /** className */
  className?: string;
  /** 1행 : 퀵 필터 칩(FilterChipBtn) */
  quickItems?: React.ReactNode;
  /** 2행 : 드롭다운 필터(DynmBtn mode="filter") */
  filterItems?: React.ReactNode;
  /** 3행 : 선택된 필터 칩(DynmBtn mode="filter" + onClose) */
  selectedItems?: React.ReactNode;
  /** 초기화 노출 여부. 미지정 시 selectedItems 유무로 판단 */
  showReset?: boolean;
  /** onReset */
  onReset?: () => void;
}

const LpFilterBar = ({
  className,
  quickItems,
  filterItems,
  selectedItems,
  showReset,
  onReset,
}: IProps) => {
  const hasQuick = React.Children.count(quickItems) > 0;
  const hasFilter = React.Children.count(filterItems) > 0;
  const hasSelected = React.Children.count(selectedItems) > 0;
  const isReset = showReset ?? hasSelected;

  /**
   선택칩 행이 없으면 드롭다운 필터와 sorting-bar가 붙어버린다.
   템플릿이 케이스별 간격을 잡을 수 있도록 이 상태를 data 속성으로 노출한다.
   */
  const hasSelectedRow = hasSelected || isReset;

  /**
   className에는 고정값만 둔다. 렌더마다 값이 바뀌면 React가 className을 통째로
   다시 써서, 페이지가 스크롤 고정용으로 붙여둔 is-pinned까지 지워진다.
   */
  const cName = classNameBind(['lp-filter-bar', className || '']);

  return (
    <S.LpFilterBar
      className={cName}
      data-has-selected={hasSelectedRow ? 'true' : 'false'}
    >
      {/* 1행(퀵 필터)은 .pin-area 밖에 두어 스크롤 고정 대상에서 제외한다 */}
      {hasQuick && (
        <S.Area className="area-quick">
          <S.List className="list">{quickItems}</S.List>
        </S.Area>
      )}

      {/* 스크롤 고정(is-pinned / sticky) 시 .pin-area만 고정 대상이 된다 */}
      {(hasFilter || hasSelectedRow) && (
        <S.PinArea className="pin-area">
          {hasFilter && (
            <S.Area className="area-filter">
              <S.List className="list">{filterItems}</S.List>
            </S.Area>
          )}

          {hasSelectedRow && (
            <S.Area className="area-selected">
              <S.List className="list">{selectedItems}</S.List>
              {isReset && (
                <S.Reset className="area-reset">
                  <Button label="필터 초기화" onClick={onReset}>
                    <Text>초기화</Text>
                  </Button>
                </S.Reset>
              )}
            </S.Area>
          )}
        </S.PinArea>
      )}
    </S.LpFilterBar>
  );
};

export default memo(LpFilterBar);
